import jQuery from 'jquery';
var Parse = require('parse');


export const getFullPageCount = async () => {
    var MediaLibrary = Parse.Object.extend("MediaLibrary");
    var query = new Parse.Query(MediaLibrary);
    query.equalTo("status", true);
    query.descending("createdAt");
    const count = await query.count();

    return count;
}

export const getSearchResults = async (searchdatas) => {
    var MediaLibrary = Parse.Object.extend("MediaLibrary");
    var query = new Parse.Query(MediaLibrary);
    query.descending("createdAt");
    query.equalTo("status", true);

    if (searchdatas['searchbox']) {
        query.matches("name", searchdatas['searchbox'], 'i');
    }

    if (searchdatas['statsrc'] == "true") {
        query.equalTo("status", true);
    } else if (searchdatas['statsrc'] == "false") {
        query.equalTo("status", false);
    }
    return query.find().then((records) => {
        return records;
    }, (error) => {
    });

}

export const getMediaLibrary = async (pagenum, dataperpage, sortitem, sortitemorder) => {
    var skipnum = pagenum - 1;
    var perpage = parseInt(dataperpage);

    var MediaLibrary = Parse.Object.extend("MediaLibrary");
    var query = new Parse.Query(MediaLibrary);
    query.equalTo("status", true);

    if (sortitem !== "") {
        if (sortitemorder === "ascending") {
            query.ascending(sortitem);
        } else {
            query.descending(sortitem);
        }

    } else {
        query.descending('createdAt');
    }

    query.skip(skipnum * perpage);
    query.limit(perpage);

    return query.find().then((records) => {
        return records;
    }, (error) => {
    });
}

export const hideRecords = async (objectids) => {

    var parseobject = Parse.Object.extend("MediaLibrary");
    var query = new Parse.Query(parseobject);
    query.equalTo("objectId", objectids);
    return query.find().then((object) => {
        var realbject = object[0];
        realbject.set("status", false);
        return realbject.save().then((records) => {
            return true;
        }, (error) => {
            console.log(error);
        }).catch(function (error) {
        });

    }, (error) => {
    });


}


export const addRecord = async ({ name, icon, status, description }) => {
    var obj = new Parse.Object("MediaLibrary");
    obj.set("name", name);
    obj.set("icon", icon);
    obj.set("description", description);
    if (status === 'false') {
        obj.set("status", false);
    } else {
        obj.set("status", true);
    }


    return obj.save().then((obj) => {
        return obj;
    }, (error) => {
        return false;
    }).catch(function (error) {
        return false;
    });
}


export const fetchRecordById = async ({ objectid }) => {
    var MediaLibrary = Parse.Object.extend("MediaLibrary");
    var query = new Parse.Query(MediaLibrary);
    query.equalTo("objectId", objectid);
    return query.find().then((records) => {
        return records;
    }, (error) => {
        return false;
    }).catch(function (error) {
        return false;
    });
}


export const updateRecord = async ({ edithiddenid, name, icon, description, status }) => {
    var MediaLibrary = Parse.Object.extend("MediaLibrary");
    var query = new Parse.Query(MediaLibrary);
    query.equalTo("objectId", edithiddenid);

    return query.find().then((object) => {

        var realbject = object[0];

        realbject.set("name", name);
        console.log(icon.length)
        if (icon.length > 0) {
            realbject.set("icon", icon);
        }
        realbject.set("description", description);
        if (status === 'false') {
            realbject.set("status", false);
        } else {
            realbject.set("status", true);
        }

        return realbject.save().then((records) => {
            return true;
        }, (error) => {
            return false;
        }).catch(function (error) {
            return false;
        });

    }, (error) => {
        return false;
    });

}




export const checkFieldValid = (addoredit) => {

    var name = jQuery('#name');
    var logofile = jQuery('#logofile');

    var errstat = true;
    if (name.val() === "") {
        name.addClass("is-invalid");
        errstat = false;
    } else {
        name.removeClass("is-invalid");
    }




    if (addoredit === "add") {
        if (logofile.val() === "") {
            logofile.addClass("is-invalid");
            errstat = false;
        } else {
            logofile.removeClass("is-invalid");
        }
    }


    if (errstat === false) {
        return false;
    } else {
        return true;
    }

}

